export default __webpack_public_path__ + "static/media/guia-3-1.483a6c35.svg";